// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"6d36e420","359":"d84da19f","448":"528e0497"}[chunkId] + ".chunk.js";
};